import { FiX, FiTag, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import ButtonLoading from './ButtonLoading';

const AddFeeModal = ({ closeModal, addonName, setAddonName, addonPrice, setAddonPrice, submitHandler, loading, error, success }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" onClick={closeModal} />

      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-md z-10">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-indigo-50 rounded-xl">
              <FiTag className="text-indigo-600 text-lg" />
            </div>
            <h3 className="text-base font-semibold text-gray-900">Add Extra Fee</h3>
          </div>
          <button
            type="button"
            onClick={closeModal}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          {error && (
            <div className="flex items-start gap-3 bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm">
              <FiAlertCircle className="mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
          )}
          {success && (
            <div className="flex items-start gap-3 bg-green-50 border border-green-200 text-green-700 rounded-xl px-4 py-3 text-sm">
              <FiCheckCircle className="mt-0.5 shrink-0" />
              <span>Extra fee added successfully!</span>
            </div>
          )}

          <form onSubmit={submitHandler} className="space-y-4">
            <div>
              <label className="block mb-1.5 text-sm font-medium text-gray-700">Fee Name</label>
              <input
                type="text"
                value={addonName}
                onChange={(e) => setAddonName(e.target.value)}
                placeholder="e.g. Note book"
                className="w-full rounded-xl bg-gray-50 border border-gray-200 px-4 py-2.5 text-sm focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none"
              />
            </div>
            <div>
              <label className="block mb-1.5 text-sm font-medium text-gray-700">Price (₦)</label>
              <input
                type="number"
                value={addonPrice}
                onChange={(e) => setAddonPrice(e.target.value)}
                placeholder="e.g. 20000"
                className="w-full rounded-xl bg-gray-50 border border-gray-200 px-4 py-2.5 text-sm focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none"
              />
            </div>

            {loading ? (
              <ButtonLoading styles="w-full text-white bg-indigo-400 font-medium rounded-full text-sm px-5 py-2.5 text-center" />
            ) : (
              <button
                type="submit"
                className="w-full text-white bg-indigo-600 hover:bg-indigo-700 font-medium rounded-full text-sm px-5 py-2.5 transition-colors"
              >
                Save Fee
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddFeeModal;
